// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etfs-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.etfs-header {
  margin-bottom: 2rem;
}

.etfs-header h2 {
  color: #333;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.etfs-header p {
  color: #666;
  font-size: 1.1rem;
}

.etfs-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  padding: 1rem;
  background: #f9f9f9;
  border-radius: 8px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
}

.filter-group label {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.filter-input,
.filter-select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95rem;
}

.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.etfs-stats {
  display: flex;
  gap: 2rem;
  margin-bottom: 1.5rem;
  padding: 0.75rem;
  background: #f0f0f0;
  border-radius: 6px;
  font-size: 0.95rem;
}

.etfs-stats strong {
  color: #667eea;
}

.etfs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.etf-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;
}

.etf-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.etf-header {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f0f0f0;
}

.etf-header h3 {
  color: #667eea;
  font-size: 1.5rem;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}

.etf-name {
  color: #666;
  font-size: 0.95rem;
  display: block;
}

.etf-details {
  margin-bottom: 1rem;
}

.etf-detail {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f5f5f5;
}

.etf-detail:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #666;
  font-size: 0.9rem;
}

.detail-value {
  color: #333;
  font-size: 0.9rem;
  text-align: right;
}

.policy-accumulating {
  color: #10b981;
  font-weight: 600;
}

.policy-distributing {
  color: #f59e0b;
  font-weight: 600;
}

.etf-description {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
}

.etf-description p {
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}

.etf-notes {
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f9f9f9;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #666;
  border-left: 3px solid #667eea;
}

.no-results {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.loading,
.error {
  text-align: center;
  padding: 3rem;
  font-size: 1.1rem;
}

.error {
  color: #dc2626;
}

@media (max-width: 768px) {
  .etfs-grid {
    grid-template-columns: 1fr;
  }
  
  .etfs-filters {
    flex-direction: column;
  }
  
  .filter-group {
    min-width: 100%;
  }
}
















`, "",{"version":3,"sources":["webpack://./src/ETFs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".etfs-container {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.etfs-header {\n  margin-bottom: 2rem;\n}\n\n.etfs-header h2 {\n  color: #333;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.etfs-header p {\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.etfs-filters {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  padding: 1rem;\n  background: #f9f9f9;\n  border-radius: 8px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 200px;\n}\n\n.filter-group label {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.filter-input,\n.filter-select {\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.95rem;\n}\n\n.filter-input:focus,\n.filter-select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.etfs-stats {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 1.5rem;\n  padding: 0.75rem;\n  background: #f0f0f0;\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.etfs-stats strong {\n  color: #667eea;\n}\n\n.etfs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.etf-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.2s ease;\n}\n\n.etf-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.etf-header {\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.etf-header h3 {\n  color: #667eea;\n  font-size: 1.5rem;\n  margin: 0 0 0.5rem 0;\n  font-weight: 600;\n}\n\n.etf-name {\n  color: #666;\n  font-size: 0.95rem;\n  display: block;\n}\n\n.etf-details {\n  margin-bottom: 1rem;\n}\n\n.etf-detail {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.etf-detail:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  font-weight: 500;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.detail-value {\n  color: #333;\n  font-size: 0.9rem;\n  text-align: right;\n}\n\n.policy-accumulating {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.policy-distributing {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n.etf-description {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #f0f0f0;\n}\n\n.etf-description p {\n  color: #555;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.etf-notes {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background: #f9f9f9;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  color: #666;\n  border-left: 3px solid #667eea;\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n}\n\n.loading,\n.error {\n  text-align: center;\n  padding: 3rem;\n  font-size: 1.1rem;\n}\n\n.error {\n  color: #dc2626;\n}\n\n@media (max-width: 768px) {\n  .etfs-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .etfs-filters {\n    flex-direction: column;\n  }\n  \n  .filter-group {\n    min-width: 100%;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
